// @flow
import { connect } from 'react-redux';
import ScribeScrollWithTranscript from './ScribeScrollWithTranscript';

const mapStateToProps = state => {
  const {
    transcriptsCurrent,
    ui: { keyboardInputShown },
    transcripts,
  } = state.scribeConversation;
  const { sidebar, lightView } = state.scribeSession;
  const { fullScreen, bottomMenu, electronCaptionMode } = state.scribeTranscriptUI;

  return {
    bottomMenu,
    electronCaptionMode,
    fullScreen,
    lightView,
    keyboardInputShown,
    sidebar,
    transcriptsCurrent,
    transcript: transcripts[transcriptsCurrent[transcriptsCurrent.length - 1]],
    transcripts,
  };
};

export default connect(mapStateToProps)(ScribeScrollWithTranscript);
